import { BoycottHeaderProps } from "../editor/headerTypes";
import applyTextMask from "../render/applyTextMask";
import { calcTextSize } from "../render/calcTextSize";


/**
 * Draws a boycott type header onto the canvas using the given props.
 * 
 * TODO consider if some of this should be offloaded to a worker
 * 
 * @returns height of the header that was drawn
 */
export default function drawBoycottHeader(
  canvas: HTMLCanvasElement,
  margin: number,
  headerProps: BoycottHeaderProps,
  maskImg: HTMLImageElement,
  reduceHeight: boolean,
) {
  const ctx = canvas.getContext("2d");
  //const rect = canvas.getBoundingClientRect();
  const w = 2480; // Matches css canvas width times scale factor 
  const h = 3510;
  canvas.width = w;
  canvas.height = h;

  // Clear the canvas
  ctx.clearRect(0, 0, canvas.width, canvas.height);

  const fontStr = '"Arial Black", Impact';
  //const fontStr = 'Impact';

  // Header size calcs
  const availableWidth = w - 2 * margin
  const textSize = calcTextSize(headerProps.bigHeader1, fontStr,
    250, 500, 0.1, availableWidth)
  
  // First big header line
  const ey1 = margin + textSize.actualBoundingBoxAscent
  applyTextMask(canvas, ctx, headerProps.bigHeader1, textSize.offsetX + margin, ey1, 
    headerProps.bigColor, `${textSize.fontSize}px ${fontStr}`, textSize.letterSpacing, maskImg, 0, 0, canvas.width, canvas.width * maskImg.height / maskImg.width);

  const bigLineGap = reduceHeight ? 0.25 : 0.5
  const bottomMargin = reduceHeight ? 0.3 : 0.5

  // Measure if we need to reduce the size of the second line
  var bigHeaderFont2 = `${textSize.fontSize}px ${fontStr}`
  ctx.font = bigHeaderFont2
  ctx.letterSpacing = `${textSize.letterSpacing}px`
  const bigHeaderMetrics2 = ctx.measureText(headerProps.bigHeader2)
  ctx.font = `${textSize.fontSize * 0.25}px ${fontStr}`
  ctx.letterSpacing = '0px'
  const testSloganMetrics1 = ctx.measureText(headerProps.smallHeader1)
  const testSloganMetrics2 = ctx.measureText(headerProps.smallHeader2)
  const testWidth = bigHeaderMetrics2.actualBoundingBoxLeft + bigHeaderMetrics2.actualBoundingBoxRight
    + Math.max(testSloganMetrics1.actualBoundingBoxLeft + testSloganMetrics1.actualBoundingBoxRight,
      testSloganMetrics2.actualBoundingBoxLeft + testSloganMetrics2.actualBoundingBoxRight)
    + 0.5 * textSize.actualBoundingBoxAscent
  var ey2: number = 0  
  var factor = 1
  if (testWidth > availableWidth) {
    factor = availableWidth / testWidth
    ey2 = ey1 + bigLineGap * textSize.actualBoundingBoxAscent + textSize.actualBoundingBoxAscent * factor
    applyTextMask(canvas, ctx, headerProps.bigHeader2, factor * textSize.offsetX + margin, ey2,
      headerProps.bigColor, `${textSize.fontSize * factor}px ${fontStr}`, textSize.letterSpacing * factor, maskImg, 0, 0, canvas.width, canvas.width * maskImg.height / maskImg.width);
  } else {
    ey2 = ey1 + (1.0 + bigLineGap) * textSize.actualBoundingBoxAscent
    applyTextMask(canvas, ctx, headerProps.bigHeader2, textSize.offsetX + margin, ey2,
      headerProps.bigColor, `${textSize.fontSize}px ${fontStr}`, textSize.letterSpacing, maskImg, 0, 0, canvas.width, canvas.width * maskImg.height / maskImg.width);  
  } 

  // Slogans
  const sloganFontSize = textSize.fontSize * 0.25 * factor;
  ctx.fillStyle = headerProps.smallColor
  ctx.font = `${sloganFontSize}px ${fontStr}`
  const sloganMetrics2 = ctx.measureText(headerProps.smallHeader2)
  ctx.fillText(headerProps.smallHeader2, w - margin - sloganMetrics2.width, ey2 - 0.1 * sloganMetrics2.actualBoundingBoxAscent)
  const sloganMetrics1 = ctx.measureText(headerProps.smallHeader1)
  ctx.fillText(headerProps.smallHeader1, w - margin - sloganMetrics1.width, ey2 - 1.8 * sloganMetrics1.actualBoundingBoxAscent)

  return Math.floor(ey2 + bottomMargin * textSize.actualBoundingBoxAscent)
}